import { ArrowRight, Minus, Plus } from "lucide-react";

import type { WorkloadDiff } from "@/api/local/workload";

interface Props {
  diffs: WorkloadDiff[];
}

/**
 * Render a `diffWorkloadSpec()` result as a readable table.
 *
 *   field            before        →  after
 *   image            vllm:0.5      →  vllm:0.6
 *   args[--max-len]  4096          →  8192
 *   args[--enforce-eager]                added
 *   env[OLD_VAR]     "abc"            removed
 */
export function WorkloadDiffView({ diffs }: Props) {
  if (diffs.length === 0) {
    return (
      <div className="diff-empty">
        no spec changes — replicas would just restart on the same image
      </div>
    );
  }
  return (
    <div className="diff">
      <div className="diff__head">
        <span>field</span>
        <span>before</span>
        <span></span>
        <span>after</span>
      </div>
      {diffs.map((d, idx) => (
        <DiffRow key={idx} diff={d} />
      ))}
    </div>
  );
}

function DiffRow({ diff }: { diff: WorkloadDiff }) {
  if (diff.path === "scalar") {
    return (
      <div className="diff__row diff__row--scalar">
        <span className="diff__field">{diff.field}</span>
        <span className="diff__before">{diff.before}</span>
        <span className="diff__arrow">
          <ArrowRight />
        </span>
        <span className="diff__after">{diff.after}</span>
      </div>
    );
  }
  if (diff.path === "added") {
    return (
      <div className="diff__row diff__row--added">
        <span className="diff__field">{diff.field}</span>
        <span className="diff__before muted">—</span>
        <span className="diff__arrow">
          <Plus />
        </span>
        <span className="diff__after">{diff.after}</span>
      </div>
    );
  }
  return (
    <div className="diff__row diff__row--removed">
      <span className="diff__field">{diff.field}</span>
      <span className="diff__before">{diff.before}</span>
      <span className="diff__arrow">
        <Minus />
      </span>
      <span className="diff__after muted">—</span>
    </div>
  );
}
